import { useLayoutEffect } from 'react'
import Header from '../Component/Header'
import Navbar from '../Component/Navbar'
import StockScanner from '../Component/StockScanner'
import { useLocation, useNavigate } from "react-router-dom";
import { Toaster } from 'sonner';
import Cookies from 'js-cookie';
import { useAuth } from '../AuthContext';
import { hasRouteAccess } from '../routePermissions';
import { useState } from 'react';

export default function DashboardLayout({children}) {
  const [navbarOpen, setNavbarOpen] = useState(false);
  const token = Cookies.get('WEB_SSR');
  const route = useNavigate();
  const location = useLocation();
  const { user, loading: authLoading, can } = useAuth();

  useLayoutEffect(() => {
    if (!token) {
      route('/');
      return;
    }

    if (!authLoading && user) {
      if (!hasRouteAccess(location.pathname, can)) {
        route('/dashboard', { replace: true });
      }
    }
  }, [token, route, authLoading, user, location.pathname, can]);

  if (!token) return null;

  const toggleNavbar = () => {
    setNavbarOpen(!navbarOpen)
  }

  return (
    <div className="flex h-screen flex-col">
      <Header toggleNavbar={toggleNavbar} />
      <div className="flex flex-1 overflow-hidden">
        <Navbar isOpen={navbarOpen} onClose={() => setNavbarOpen(false)} />
        <main className="flex-1 overflow-auto bg-background py-4 px-2">
            {children}
        </main>
      </div>
      <Toaster richColors />
    </div>
  )
}
